module.exports = __webpack_public_path__ + "static/media/logo_GWO.91ca8336.svg";